import { useState, useEffect } from "react";
import React from "react";
import {
  machineProfile,
  part,
  vendor,
  customer,
  partCategory,
  inventory as invetoryAPI,
} from "../../api";
import { toast } from "react-toastify";
import {
  dateFormat,
  getEmptyField,
  printLocation,
  renderImage,
} from "../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import NormalTextArea from "../../components/form/HorizontalNormalTextarea";
import { DatepickerOpt } from "../../components/form/DatepickerOpt";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader } from "../../components/card/card";
import { MachineElement } from "../../components/MachineElement";
import ImageViewer from "../../components/ImageViewer";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import { Badge, ListGroup, Table } from "react-bootstrap";
import { format } from "date-fns";

function setupLocationValues(locationSeq, location) {
  locationSeq.push(location.id);
  if (location.parent_location) {
    setupLocationValues(locationSeq, location.parent_location);
  }
}
function AddParts({afterSubmitCallback}) {
  const { id } = useParams();
  const editMode = !!id;
  const { locations } = useDashboardContext();
  const [sublocations, setSublocations] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");
  const [vendorList, setVendor] = useState([]);
  const [customerList, setCustomer] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [inventories, setInventories] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [preview, setPreview] = useState();
  const [machineSpec, setMachineSpec] = useState("");
  const [productManual, setProductManual] = useState("");
  const [otherDoc, setOtherDoc] = useState("");
  const [machineElements, setMachineElements] = useState([]);
  const [deletedElements, setDeletedElements] = useState([]);
  const [deletedDeployments, setDeletedDeployments] = useState([]);
  const [deletedSchedules, setDeletedSchedules] = useState([]);
  const [deletedAttachments, setDeletedAttachments] = useState([]);
  const [locationValue, setLocationValue] = useState([]);
  const { getLocationName,config } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [inventoryEditingIndex, setInventoryEditingIndex] = useState(null);

  const [dataToSend, setDataToSend] = useState({
    part_name: "",
    part_number: "",
    part_cost: "",
    vendor_id: "",
    customer_id: "",
    description: "",
    category_id: "",
  });
  const [inventory, setInventory] = useState({
    location_id: "",
    location_name: "",
    part_id: "",
    quantity: "",
    barcode: "",
    min_qty: "",
    max_qty: "",
  });
  const [open, setOpen] = React.useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const navigate = useNavigate();

  const [emptyField, setEmptyField] = useState([]);
  const [emptyFieldInventory, setEmptyFieldInventory] = useState([]);
  const [openDetailInventory, setOpenDetailInventory] = useState(false);
  const [detailInventory, setDetailInventory] = useState(null);

  function backToList() {
    navigate(-1);
  }

  const hideModal = () => {
    setOpenModal(false);
  };

  const createInventory = async () => {
    setOpenModal(true);
    emptyInventory();
    setInventoryEditingIndex(null);
  };

  const prosesInventory = async () => {
    let inv = inventories;
    let tmp = inventory;
    tmp.location_id = locationValue[sublocations.length - 1];

    console.log(inventory);
    const mandatory = ["quantity", "min_qty", "max_qty", "barcode"];
    const ef = getEmptyField(inventory, mandatory);
    if (!tmp.location_id) {
      ef.push("location_id");
    }
    setEmptyFieldInventory(ef);
    if (ef.length > 0) {
      toast.error("Mandatory field must be filled");
      return;
    }

    if (inventoryEditingIndex == null) {
      inv.push(tmp);
    } else {
      inv[inventoryEditingIndex] = tmp;
    }

    setInventories(inv);
    hideModal();
  };

  async function getMasterData() {
    try {
      setIsLoading(true);

      const getVendor = vendor.list({});

      const getCustomer = customer.list({});

      const getCategory = partCategory.list({});

      const [res, resCust, resCategory] = await Promise.all([
        getVendor,
        getCustomer,
        getCategory,
      ]);

      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.vendor_name;
            d["value"] = d.id;
          });
          setVendor(data);
        }
      }
      if (resCust.ok) {
        const body = await resCust.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.customer_name;
            d["value"] = d.id;
          });
          setCustomer(data);
        }
      }
      if (resCategory.ok) {
        const body = await resCategory.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.name;
            d["value"] = d.id;
          });
          setCategories(data);
        }
      }

      if (editMode) {
        await getRecord();
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    if (locations.length) setSublocations([locations]);
  }, [locations]);

  useEffect(() => {
    getMasterData();
  }, []);

  const deleteInventory = (index) => {
    console.log({ index });
    // delete inventories based on index of data
    let inv = inventories;
    inv.splice(index, 1);
    setInventories([...inv]);
  };

  const editInventory = (index) => {
    const inv = { ...inventories[index] };

    const invLocation = getLocationNameFromID(inv.location_id, false);
    //find parent
    const locationSeq = [];
    setupLocationValues(locationSeq, invLocation);
    locationSeq.reverse();

    setLocationValue(locationSeq);

    setInventory(inv);
    setOpenModal(true);
    setInventoryEditingIndex(index);
  };
  async function getRecord() {
    const result = await part.getOne(id);

    if (result.ok) {
      const body = await result.json();
      let data = body.data;

      const defaultValue = {
        part_name: data.part_name,
        part_number: data.part_number,
        vendor_id: data.vendor_id || "",
        customer_id: data.customer_id || "",
        description: data.description,
        category_id: data.category_id || "",
        part_cost:data.part_cost || 0
      };
      if (data.part_image) {
        setPreview(renderImage(`/machine/attachment/` + data.part_image));
      }

      setInventories(data.inventory);
      setDataToSend(defaultValue);
    }
  }

  const handleOnchange = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };

  const handleOnChangeInventory = (e) => {
    let key = e.target.name;

    setInventory((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };

  const emptyInventory = () => {
    setInventory({
      location_id: "",
      part_id: "",
      quantity: "",
      barcode: "",
      min_qty: "",
      max_qty: "",
    });
  };

  const handleMachineElementChange = (elements) => {
    setDataToSend((prevData) => ({
      ...prevData,
      deployments: JSON.stringify(elements),
    }));
  };

  const getLocationNameFromID = (val, onlyName = true) => {
    //inside locations there are sublocations array
    // check if the id is same as location or sublocations
    const loc = locations.find((l) => {
      return l.sublocations.find((s) => s.id === val);
    });
    if (loc) {
      if (loc.id === val) {
        return onlyName ? loc.location_name : loc;
      } else {
        return onlyName
          ? loc.sublocations.find((s) => s.id === val).location_name
          : loc.sublocations.find((s) => s.id === val);
      }
    }
  };

  useEffect(() => {
    let sublocations = locations;
    const copy = [sublocations];
    console.log({ locations });
    const findSublocation = (lv, index) => {
      const location = sublocations.find((l) => l.id == lv);

      if (
        location &&
        location.sublocations &&
        location.sublocations.length > 0
      ) {
        copy.splice(index + 1);
        copy.push(location.sublocations);
        sublocations = location.sublocations;
      } else {
        copy.splice(index + 1);
      }
    };

    if (locationValue.length > 0) {
      locationValue.forEach((lv, index) => {
        findSublocation(lv, index);
      });
      setSublocations(copy);
    }
  }, [locationValue]);

  const handleLocationChange = (e, index) => {
    const location_values = [...locationValue];
    location_values.splice(index);
    location_values.push(e.target.value);
    setLocationValue(location_values);
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      let payload = { ...dataToSend };
      payload["inventory"] = JSON.stringify(inventories);

      const mandatory = [
        "part_name",
        "part_cost",
        "part_number",
        "category_id",
        "description",
      ];
      const ef = getEmptyField(payload, mandatory);
      setEmptyField(ef);
      if (ef.length > 0) {
        toast.error("Mandatory field must be filled");
        return;
      }

      //console.log({ payload });

      let res;
      if (!editMode) {
        res = await part.create(payload, selectedFile);
      } else {
        res = await part.update(id, payload, selectedFile);
      }

      setIsLoading(false);
      if (res.ok) {
        toast.success("Successfully Saved");


        if (!editMode) {
          if (afterSubmitCallback) {
            afterSubmitCallback()
          } else {
            backToList();
          }
          
        }
      } else {
        toast.error("Something went wrong, please try again");
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const generateRandomQR = () => {
    //random number 16 character with prefix GR-
    //example GR-123456919191929
    // random number only wihtout string
    // example 123456919191929
    const random = Math.floor(Math.random() * 10000000000000000);
    setInventory((prevData) => ({
      ...prevData,
      ["barcode"]: `INV-${random}`,
    }));
  };

  const onSelectFile = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }

    // I've kept this example simple by using the first image instead of multiple
    setSelectedFile(e.target.files[0]);
  };

  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }
    //console.log({ selectedFile });
    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);
    //console.log({ objectUrl });
    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const handleAddNewCategory = async () => {
    if (!newCategory) return;
    const result = await partCategory.create({
      name: newCategory,
    });

    if (result.ok) {
      const body = await result.json();
      const data = body.data;
      setCategories((prev) => [{ ...data }, ...prev]);
      setNewCategory("");
    }
  };

  const handleOpenDetailInventory = async (id) => {
    try {
      setIsLoading(true);
      setOpenDetailInventory(true);
      const res = await invetoryAPI.getOne(id);
      if (res.ok) {
        const body = await res.json();
        setDetailInventory(body.data);
      }
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <LoadingIndicator open={isLoading} />
      <CardHeader>{editMode && "Edit "}Part Information</CardHeader>

      <CardBody>
        <div className="row">
          <div className="col-9">
            <div>
              <NormalInput
                required={true}
                value={dataToSend["part_name"]}
                label="Part Name"
                onchange={handleOnchange}
                name="part_name"
                emptyField={emptyField}
              />
              <NormalInput
                required={true}
                value={dataToSend["part_number"]}
                label="Part Number"
                onchange={handleOnchange}
                name="part_number"
                emptyField={emptyField}
              />
         

<div className="form-group mb-3">
      <label className="form-label" htmlFor="exampleFormControlInput1">
      Part Cost <span className="text-danger">*</span>
      </label>
<div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        {config?.currency_symbol}
                      </div>
                    </div>
                    <input
                  required={true}
                  className={`form-control ${
                    emptyField.includes('part_cost') ? "is-invalid" : ""
                  }`}
                      type={"number"}
                      value={dataToSend["part_cost"]}
                      label="Part Cost"
                      onChange={handleOnchange}
                      name="part_cost"
                      emptyField={emptyField}
                    />
                </div>
                </div>

              <NormalTextArea
                required={true}
                value={dataToSend["description"]}
                label="Description"
                onchange={handleOnchange}
                name="description"
                emptyField={emptyField}
              />
            </div>

            <NormalSelect
              required={true}
              value={dataToSend["category_id"]}
              label="Category"
              onchange={handleOnchange}
              emptyField={emptyField}
              list={categories}
              name="category_id"
              valueKey={"id"}
              onSubmit={handleAddNewCategory}
              addMoreComponent={
                <NormalInput
                  required={true}
                  value={newCategory}
                  label="Category"
                  onchange={(e) => {
                    setNewCategory(e.target.value);
                  }}
                />
              }
            />
          </div>
          <div className="col-3">
            <Card>
              <CardBody>
                <label htmlFor="files">
                  {preview ? (
                    <>
                      <img src={preview} className="img-thumbnail" alt="" />
                      <div
                        style={{
                          textAlign: "center",
                          cursor: "pointer",
                          marginTop: "5px",
                        }}
                      >
                        Change Photo <i className="fa fa-camera"></i>
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          minHeight: "150px",
                          alignItems: "center",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <i className="fa fa-camera"></i>
                        <div>Add a Photo</div>
                      </div>
                    </>
                  )}
                </label>
                <input
                  id="files"
                  onChange={onSelectFile}
                  style={{ visibility: "hidden", position: "absolute" }}
                  type="file"
                  accept="image/png, image/jpeg"
                />
              </CardBody>
            </Card>
          </div>
        </div>

        <Card>
          <LoadingIndicator open={isLoading} />
          <CardHeader>More Information</CardHeader>
          <CardBody>
            <NormalSelect
              value={dataToSend["vendor_id"]}
              label="Vendor"
              onchange={handleOnchange}
              list={vendorList}
              valueKey="id"
              name="vendor_id"
            />
            <NormalSelect
              value={dataToSend["customer_id"]}
              label="Customer"
              onchange={handleOnchange}
              list={customerList}
              valueKey="id"
              name="customer_id"
            />
          </CardBody>
        </Card>
        <Card style={{ marginTop: "10px" }}>
          <LoadingIndicator open={isLoading} />
          <CardHeader>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>Inventory List</div>

              <button
                onClick={createInventory}
                className="btn btn-sm btn-outline-theme"
              >
                Create New Inventory
              </button>
            </div>
          </CardHeader>
          <CardBody>
            <table style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>No</th>
                  <th>Location</th>
                  <th>Barcode</th>
                  <th>Available Qty</th>
                  <th>Min Qty</th>
                  <th>Max Qty</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {inventories.map((inventory, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{getLocationNameFromID(inventory.location_id)}</td>
                      <td>
                        <div style={{ width: "68px" }}>
                          <Card className="w-100 p-1">
                            <QRCode
                              size={40}
                              value={inventory["barcode"]}
                              logoImage={"/cmms/logo.png"}
                            />
                          </Card>
                        </div>
                      </td>
                      <td>{inventory.quantity}</td>
                      <td>{inventory.min_qty}</td>
                      <td>{inventory.max_qty}</td>
                      <td>
                        {inventory.id && (
                          <button
                            style={{ marginRight: "5px" }}
                            className=" btn btn-sm btn-outline-warning"
                            onClick={() => {
                              handleOpenDetailInventory(inventory.id);
                            }}
                          >
                            Logs
                          </button>
                        )}

                        <ConfirmationDlg
                          type="alert"
                          open={openDetailInventory}
                          onClose={() => setOpenDetailInventory(false)}
                        >
                          {detailInventory && (
                            <div>
                              <p>Activities</p>

                              <ListGroup as="ol" numbered>
                                {detailInventory.logs.map((l) => (
                                  <ListGroup.Item
                                    key={l.id}
                                    as="li"
                                    className="d-flex justify-content-between align-items-start"
                                  >
                                    <div className="ms-2 me-auto">
                                      <div className="fw-bold">
                                        {l.qty} items was {l.action} at{" "}
                                        {format(
                                          new Date(l.created_at),
                                          "yyyy-MM-dd hh:mm"
                                        )}{" "}
                                      </div>
                                      {l.type == "purchase order" && (
                                        <Link
                                          to={
                                            "/purchase-order/detail/" + l.ref_id
                                          }
                                        >
                                          Purchase Order Detail
                                        </Link>
                                      )}
                                    </div>
                                    <Badge bg="primary" pill>
                                      {l.qty}
                                    </Badge>
                                  </ListGroup.Item>
                                ))}
                              </ListGroup>
                            </div>
                          )}
                        </ConfirmationDlg>

                        <button
                          style={{ marginRight: "5px" }}
                          className=" btn btn-sm btn-outline-theme"
                          onClick={() => {
                            editInventory(index);
                          }}
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => {
                            deleteInventory(index);
                          }}
                          className="btn btn-sm btn-outline-danger"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </CardBody>
        </Card>
        <ConfirmationDlg
          title={"Register New Inventory"}
          open={!!openModal}
          onClose={hideModal}
          btnSubmitText={"Register"}
          btnCancelText={"Cancel"}
          onSubmit={prosesInventory}
        >
          {sublocations.map((sublocation, index) => {
            return (
              <NormalSelect
                key={index}
                required={true}
                value={locationValue[index]}
                label={getLocationName(index)}
                onchange={(e) => handleLocationChange(e, index)}
                list={sublocation}
                name={`location_id`}
                valueKey={"id"}
                textKey="location_name"
                renderFn={printLocation}
                emptyField={emptyFieldInventory}
              />
            );
          })}
          <NormalInput
            required={true}
            value={inventory["quantity"]}
            type={"number"}
            label="Quantity"
            onchange={handleOnChangeInventory}
            name="quantity"
            emptyField={emptyFieldInventory}
          />
          <NormalInput
            required={true}
            value={inventory["min_qty"]}
            type={"number"}
            label="Minimum Quantity"
            onchange={handleOnChangeInventory}
            name="min_qty"
            emptyField={emptyFieldInventory}
          />
          <NormalInput
            required={true}
            value={inventory["max_qty"]}
            type={"number"}
            label="Maximum Quantity"
            onchange={handleOnChangeInventory}
            name="max_qty"
            emptyField={emptyFieldInventory}
          />
          <div className={"row"}>
            <div className="col-sm-5">
              <div className="form-group mb-3">
                <label
                  className="form-label"
                  htmlFor="exampleFormControlInput1"
                >
                  QR Code
                </label>
                <div style={{ position: "relative", display: "block" }}>
                  <QRCode
                    value={inventory["barcode"]}
                    logoImage={"/cmms/logo.png"}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-7">
              <NormalInput
                required={true}
                value={inventory["barcode"]}
                type={"text"}
                label="Custom Barcode"
                onchange={handleOnChangeInventory}
                name="barcode"
                emptyField={emptyFieldInventory}
              />
              <button
                className="btn btn-outline-theme btn-lg"
                onClick={generateRandomQR}
              >
                Generate Random QR
              </button>
            </div>
          </div>
        </ConfirmationDlg>
        <div className="mt-4 flex">
          <button
            className="btn btn-outline-theme btn-lg me-2"
            onClick={handleSubmit}
          >
            {editMode ? "SAVE" : "ADD"}
          </button>
          <button
            className="btn btn-outline-danger btn-lg"
            onClick={afterSubmitCallback?afterSubmitCallback:backToList}
          >
            CANCEL
          </button>
        </div>
      </CardBody>
    </Card>
  );
}

export default AddParts;
